<template>
  <v-dialog persistent v-bind="[$attrs, $props]" width="800">
    <v-form ref="form" class="white px-11 py-10">
      <v-row>
        <v-col cols="11">
          <p class="form__title mb-0 gray--text">
            MIGRAR CARTEIRA PARA:
          </p>
        </v-col>
        <v-col cols="1" class="text-end pb-5">
          <BaseButton
            text
            icon
            @click="closeModal"
            class="justify-end align-start"
          >
            <v-icon size="17" color="gray" class="justify-end">
              fa-times
            </v-icon>
          </BaseButton>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <BaseFormSelect
            placeholder="Selecione"
            :items="items"
            item-text="nome"
            item-value="id"
            :return-object="true"
            label-text="Nome"
            required
            :rules="[requiredInput]"
            v-model="selectedItem"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <div class="d-flex">
            <span
              class="wallet-transfer__warning py-3 px-4 font-weight-bold caption"
            >
              *Essa ação realiza a troca do atendimento do atendente nos limites
              de crédito cadastrado nos grupos financeiros.
            </span>
          </div>
        </v-col>
      </v-row>
      <v-row class="justify-end mt-10">
        <v-col cols="12" sm="3">
          <BaseButton
            v-html="'MIGRAR'"
            class="secondary font-weight-bold"
            width="100%"
            @click="transferWallet"
            :disabled="!selectedItem"
          />
        </v-col>
      </v-row>
    </v-form>
  </v-dialog>
</template>

<script>
import { requiredInput } from "@/utils/rules.js";

export default {
  name: "WalletTransferModal",
  props: {
    items: { type: Array }
  },
  data: () => ({
    requiredInput,
    selectedItem: null
  }),
  methods: {
    closeModal() {
      this.$emit("close");
    },
    transferWallet() {
      this.$emit("transfer-wallet", this.selectedItem.id);
      this.closeModal();
    }
  }
};
</script>

<style lang="sass">
.wallet-transfer
  &__warning
    background-color: var(--v-yellow-base)
    border-radius: 4px
    flex: initial
</style>
